import {
  FiltersBottomActionsContainer,
  FiltersBottomContainer,
  FiltersCarouselContainer,
  FiltersClearAllButton,
} from "@js/apps/common/components/filters/components";
import { FiltersCarousel } from "@js/apps/common/components/filters/components/filters-carousel";
import {
  RoleFilter,
  SkillsFilter,
} from "@js/apps/common/components/filters/fields";
import {
  CommitmentFilter,
  JobTypeFilter,
  LocationFilter,
  RateFilter,
} from "@js/apps/jobs/apps/listing/fields";
import { JobOpeningResultsCount } from "@js/apps/jobs/components/job-opening-results-count";
import { useResetQueryExceptUTM } from "@js/hooks/use-reset-query-except-utm";

export const PublicJobListingFiltersForm = ({
  openingsCount,
  isAnyFilterApplied,
}: {
  openingsCount: number;
  isAnyFilterApplied: boolean;
}) => {
  const { resetQueryExceptUTM } = useResetQueryExceptUTM();

  const clearFilters = () => {
    resetQueryExceptUTM();
  };

  return (
    <>
      <FiltersCarouselContainer>
        <FiltersCarousel items={FILTER_ITEMS_FOR_PUBLIC_JOBS_LISTING} />
      </FiltersCarouselContainer>
      <FiltersBottomContainer>
        <FiltersBottomActionsContainer>
          <JobOpeningResultsCount openingsCount={openingsCount} />
          {isAnyFilterApplied && (
            <FiltersClearAllButton onClick={clearFilters} />
          )}
        </FiltersBottomActionsContainer>
      </FiltersBottomContainer>
    </>
  );
};

const FILTER_ITEMS_FOR_PUBLIC_JOBS_LISTING = [
  <RoleFilter key="role-filter" />,
  <SkillsFilter key="skills-filter" />,
  <RateFilter key="rate-filter" />,
  <LocationFilter key="location-filter" />,
  <CommitmentFilter key="commitment-filter" />,
  <JobTypeFilter key="job-type-filter" />,
];
